(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
(function() {
  'use strict';

  // ── Custom Sort Dropdown ──
  const sortToggle = document.getElementById('sort-toggle');
  const sortOptions = document.getElementById('sort-options');
  
  if (sortToggle && sortOptions) {
    // Open/Close toggle
    sortToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      sortOptions.classList.toggle('is-open');
    });

    // Close on click outside
    document.addEventListener('click', function() {
      sortToggle.setAttribute('aria-expanded', 'false');
      sortOptions.classList.remove('is-open');
    });

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        sortToggle.setAttribute('aria-expanded', 'false');
        sortOptions.classList.remove('is-open');
      }
    });

    // Handle option click
    sortOptions.querySelectorAll('.collection-sort__option').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const value = this.getAttribute('data-value');
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.toString();
      });
    });
  }

  // ── Filter checkboxes: auto-submit form ──
  document.querySelectorAll('[data-filter-checkbox]').forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      // Remove all filter params first
      document.querySelectorAll('[data-filter-checkbox]').forEach(cb => {
        params.delete(cb.name);
      });

      // Re-add checked ones
      document.querySelectorAll('[data-filter-checkbox]:checked').forEach(cb => {
        params.append(cb.name, cb.value);
      });

      url.search = params.toString();
      window.location.href = url.toString();
    });
  });

  // ── Price range apply ──
  const priceApply = document.querySelector('[data-filter-price-apply]');
  if (priceApply) {
    priceApply.addEventListener('click', function() {
      const minInput = document.querySelector('[data-filter-price-min]');
      const maxInput = document.querySelector('[data-filter-price-max]');
      if (!minInput || !maxInput) return;

      const url = new URL(window.location.href);
      if (minInput.value) url.searchParams.set(minInput.name, minInput.value);
      if (maxInput.value) url.searchParams.set(maxInput.name, maxInput.value);
      window.location.href = url.toString();
    });
  }

  // ── Sidebar toggle ──
  const filterToggle = document.getElementById('filter-toggle');
  const layout = document.querySelector('.collection-main__layout');
  if (filterToggle && layout) {
    filterToggle.addEventListener('click', function() {
      const isHidden = layout.hasAttribute('data-sidebar-hidden');
      if (isHidden) {
        layout.removeAttribute('data-sidebar-hidden');
        filterToggle.setAttribute('aria-expanded', 'true');
      } else {
        layout.setAttribute('data-sidebar-hidden', '');
        filterToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-editorial"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const slider = document.querySelector('.hero-slider');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.hero-slider__slide'));
  if (slides.length === 0) return;
  const dots = Array.from(slider.querySelectorAll('.hero-slider__dot-btn'));
  const prevBtn = slider.querySelector('[data-slider-prev]');
  const nextBtn = slider.querySelector('[data-slider-next]');
  
  let current = 0;
  let timer = null;
  const autoplay = slider.dataset.autoplay !== 'false';
  const delay = parseInt(slider.dataset.delay, 10) || 5000;

  const showSlide = (index) => {
    slides[current].classList.remove('is-active');
    if (dots.length && dots[current]) dots[current].classList.remove('is-active');
    
    current = (index + slides.length) % slides.length;
    
    slides[current].classList.add('is-active');
    if (dots.length && dots[current]) dots[current].classList.add('is-active');
  };

  const startTimer = () => {
    if (!autoplay) return;
    clearInterval(timer);
    timer = setInterval(() => {
      showSlide(current + 1);
    }, delay);
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      showSlide(current - 1);
      startTimer();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      showSlide(current + 1);
      startTimer();
    });
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      showSlide(parseInt(dot.dataset.dotIndex, 10));
      startTimer();
    });
  });

  startTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-complementary"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(entries[0].target);

    const url = entries[0].target.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const div = document.createElement('div');
        div.innerHTML = html;
        const recommendations = div.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length > 0) {
          entries[0].target.innerHTML = recommendations.innerHTML;
          if (window.AstitvaAnimations) window.AstitvaAnimations.refresh();
        }
      })
      .catch(e => console.error(e));
  };

  const section = document.querySelector('.product-recommendations');
  if (section) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(section);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  const currentHandle = section.dataset.productHandle;
  const limit = parseInt(section.dataset.limit, 10) || 4;
  const storageKey = 'astitva-recently-viewed';

  // 1. Get history
  let history = [];
  try {
    history = JSON.parse(localStorage.getItem(storageKey)) || [];
  } catch (e) {}

  // 2. Add current product to history
  if (currentHandle) {
    history = history.filter(h => h !== currentHandle);
    history.unshift(currentHandle);
    history = history.slice(0, limit + 1); // Keep one extra in case current is filtered
    try {
      localStorage.setItem(storageKey, JSON.stringify(history));
    } catch (e) {}
  }

  // 3. Filter out current product for display
  const displayHandles = history.filter(h => h !== currentHandle).slice(0, limit);

  if (displayHandles.length === 0) {
    section.classList.add('hidden');
    return;
  }

  // 4. Fetch details and render
  const grid = document.getElementById('recently-viewed-grid');
  if (!grid) return;

  const renderProducts = async () => {
    let html = '';
    
    for (const handle of displayHandles) {
      try {
        const res = await fetch(`/products/${handle}?view=card`);
        if (res.ok) {
          const text = await res.text();
          // Extract card html if we rendered it using a product card alternate template,
          // or we can fetch JSON and build it.
          // For simplicity, we can fetch product card HTML using section rendering API,
          // or `/products/handle?sections=featured-product-card`.
          // Let's fallback to standard JSON API rendering to avoid template dependency.
          const jsonRes = await fetch(`/products/${handle}.js`);
          const product = await jsonRes.json();
          html += renderCardHTML(product);
        }
      } catch (e) {}
    }

    if (html) {
      grid.innerHTML = html;
      section.classList.remove('hidden');
      if (window.AstitvaAnimations) window.AstitvaAnimations.refresh();
    } else {
      section.classList.add('hidden');
    }
  };

  const renderCardHTML = (p) => {
    const featuredImage = p.featured_image || '';
    const hoverImage = p.images[1] ? p.images[1] : '';
    const formattedPrice = (p.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    const comparePriceHTML = p.compare_at_price > p.price 
      ? `<span class="price__compare">${(p.compare_at_price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' })}</span>`
      : '';

    return `
      <li class="product-grid__item" data-reveal>
        <article class="product-card" data-product-id="${p.id}">
          <div class="product-card__media ratio-container ratio-portrait">
            <a href="${p.url}" class="product-card__image-link" tabindex="-1">
              <img src="${featuredImage}" alt="${p.title}" class="product-card__img product-card__img--primary" loading="lazy">
              ${hoverImage ? `<img src="${hoverImage}" alt="${p.title}" class="product-card__img product-card__img--hover" loading="lazy">` : ''}
            </a>
          </div>
          <div class="product-card__info">
            <p class="product-card__vendor eyebrow">${p.vendor}</p>
            <h3 class="product-card__title">
              <a href="${p.url}" class="product-card__title-link">${p.title}</a>
            </h3>
            <div class="product-card__price-row">
              <div class="price">
                <div class="price__row">
                  <span class="price__current">${formattedPrice}</span>
                  ${comparePriceHTML}
                </div>
              </div>
            </div>
          </div>
        </article>
      </li>
    `;
  };

  renderProducts();
})();

  } catch(e) { console.error(e); }
})();
})();
